import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface FilterChipProps {
  label: string;
  value: string;
  onDelete: (value: string) => void;
}

const FilterChip = ({ label, value, onDelete }: FilterChipProps) => {
  return (
    <Chip
      label={label}
      deleteIcon={<CloseIcon sx={{ fontSize: '14px !important' }} />}
      onDelete={() => onDelete(value)}
      sx={{
        backgroundColor: '#E6F6FD !important',
        color: '#333333 !important',
        border: 'none !important',
        minWidth: '120px',
        maxWidth: '100%',
        height: '38px',
        fontSize: '0.9375rem',
        paddingRight: '40px !important',
        paddingLeft: '16px !important',
        position: 'relative',
        '& .MuiChip-label': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          paddingRight: 0,
          paddingLeft: 0,
          maxWidth: '100%'
        },
        '& .MuiChip-deleteIcon': {
          color: '#333333 !important',
          position: 'absolute !important',
          right: '10px !important',
          top: '50%',
          transform: 'translateY(-50%)',
          margin: '0 !important',
          fontSize: '16px',
          '&:hover': {
            backgroundColor: 'transparent !important',
            color: '#333333 !important'
          }
        }
      }}
    />
  );
};

export default FilterChip;
